// extracted by mini-css-extract-plugin
export default {"main":"loading-wrapper_main__7kL9t"};